import React, { Component } from 'react';
import Select from 'react-select';

class GeoLocation extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            cityList:null,
            provinceList:null,
            countyList:null,
            cityId:null,
            provinceId:null,
            countyId:null,
            AllCityList:null
         }

         this.cityListChange=this.cityListChange.bind(this);
         this.countyListChange=this.countyListChange.bind(this);
         this.provinceListChange=this.provinceListChange.bind(this);
    }

    cityListChange(item)
    {
        if(item)
        {
            this.setState({
                cityId:item.value,
                provinceId:item.ProvinceId,
                countyId:item.CountyId
            })

        }
        const {AllCityList}=this.state;
        console.log(this.props);
        let selected=AllCityList!=null ?AllCityList.find(x=>x.Id==item.value):null;
        this.props.OnSelectChange(selected)
        
    }

    provinceListChange(item)
    {
        if(item)
        {
            this.setState({
               
                provinceId:item.value,
                countyId:null,
                cityId:null
            })

        }
       
    }
    countyListChange(item)
    {
        if(item)
        {
            this.setState({
               
                provinceId:item.ProvinceId,
                countyId:item.value,
                cityId:null
                
            })

        }
       
    }

    componentWillReceiveProps(newProps)
    {
        const {citylist,provincelist,countylist,value}=newProps;

        if(value)
        {
            console.log('valueee',value)
            this.setState({
                cityId:value.Id,
                countyId:value.CountyId,
                provinceId:value.ProvinceId
            });
        }

        if(provincelist)
        {
            var _provincelist=[];

            provincelist.map((item)=>{
               
                _provincelist.push({
                    value:item.Id,
                 
                    label:item.Title
                });
                return ;
            })
  
            this.setState({
                provinceList:_provincelist
            })
        }

        if(countylist)
        {
            var _countyList=[];

            countylist.map((item)=>{
               
                _countyList.push({
                    value:item.Id,
                    ProvinceId:item.Province.Id,                  
                    label:item.Title
                });
                return ;
            })
  
            this.setState({
                countyList:_countyList
            })
        }

               
        if(citylist)
        {
            var _cityList=[];

            citylist.map((item)=>{
               
                _cityList.push({
                    value:item.Id,
                    ProvinceId:item.County.ProvinceId,
                    CountyId:item.CountyId,
                    label:item.Title
                });
                return ;
            })
  
            this.setState({
                cityList:_cityList,
                AllCityList:citylist
            })
        }
    }
    render() { 
        const {cityList,provinceList,countyList,cityId,countyId,provinceId}= this.state;

        return ( 
            <div className="form-group">
                <div style={{marginBottom:3}}>
                <label className="control-label col-sm-2">استان</label>
                <Select
                    value={provinceId && provinceList && provinceList.constructor === Array ? provinceList.find(x=>x.value==provinceId) : null}
                    onChange={this.provinceListChange} 
                    className="col-sm-10"                                                                                         
                    options={provinceList && provinceList.constructor === Array ? provinceList : []}                 
                    clearable={true}
                    placeholder="انتخاب کنید"
                    noResultsText="نتیجه‌ای یافت نشد"
                    name="ProvinceId"
                    ref="ProvinceId"                    
                />
                </div>
                <div style={{marginBottom:3}}>
                <label className="control-label col-sm-2">شهرستان</label>
                <Select  
                    onChange={this.countyListChange}
                    value={countyId && countyList && countyList.constructor === Array ? countyList.find(x=>x.value==countyId) : null}
                    className="col-sm-10"                                                                                         
                    options={countyList && countyList.constructor === Array ? countyList.filter(x=>x.ProvinceId==provinceId) : []}                 
                    clearable={true}
                    placeholder="انتخاب کنید"
                    noResultsText="نتیجه‌ای یافت نشد"
                    name="CountyId"
                    ref="CountyId"                    
                />
               </div>
               <div style={{marginBottom:3}}>

                <label className="control-label col-sm-2">شهر</label>
                <Select
                    className="col-sm-10" 
                    value={cityId && cityList && cityList.constructor === Array ? cityList.find(x=>x.value==cityId) : null}
                    onChange={this.cityListChange}                                                                                          
                    options={cityList && cityList.constructor === Array ? cityList.filter(x=>x.CountyId==countyId) : []}                 
                    clearable={true}
                    placeholder="انتخاب کنید"
                    noResultsText="نتیجه‌ای یافت نشد"
                    name="CityId"
                    ref="CityId"                    
                />
                </div>

            </div>
         );
    }
}
 
export default GeoLocation;